import { AppModule } from './app.module'
import { platformBrowserDynamic } from '../../shared/browser/main.bootstrap'

platformBrowserDynamic().bootstrapModule(AppModule)
